import { OCTA_DESK_PHONE } from '@/constants/phones'
import { parseISOtoDate } from '@/helpers'
import { Download } from '@mui/icons-material'
import { Button } from '@mui/material'
import { isBefore, startOfDay } from 'date-fns'

function toCivilDay(date: string | Date) {
  const iso = typeof date === 'string' ? date : date.toISOString()
  return startOfDay(parseISOtoDate(iso))
}

const ACCOUNTING_WHATSAPP = `https://api.whatsapp.com/send?phone=${OCTA_DESK_PHONE}&text=${encodeURIComponent('Olá, gostaria de solicitar o recálculo de uma guia vencida.')}`

type GuideActionButtonProps = {
  dueDate: string | Date
  onDownload: () => void
  paid: boolean
  recalculationRequested?: boolean
  url: string | null
}

export function GuideActionButton({
  dueDate,
  onDownload,
  paid,
  recalculationRequested = false,
  url,
}: GuideActionButtonProps) {
  if (recalculationRequested) {
    return (
      <Button variant="outlined" size="small" disabled>
        Recálculo solicitado
      </Button>
    )
  }

  const isOverdue =
    !paid && isBefore(toCivilDay(dueDate), startOfDay(new Date()))

  if (isOverdue) {
    return (
      <Button
        variant="outlined"
        size="small"
        component="a"
        href={ACCOUNTING_WHATSAPP}
        target="_blank"
        rel="noopener noreferrer"
      >
        Solicitar recálculo da guia vencida
      </Button>
    )
  }

  if (!paid && url) {
    return (
      <Button
        variant="outlined"
        size="small"
        startIcon={<Download />}
        onClick={onDownload}
      >
        Baixar guia
      </Button>
    )
  }

  return null
}
